import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { pageview } from "./utils/gtag";
import "./App.css";
import SuccessScreen from "./pages/SuccessScreen";
import Form from "./pages/FormScreen";
import EventLandingPage from "./pages/EventLandingPage";
import BusinessLandingPage from "./pages/BusinessLandingPage";
import CampanaScreen from "./pages/CampanaScreen";
import CuentaMesaScreen from "./pages/CuentaMesaScreen";
import CuentaMesaOkScreen from "./pages/CuentaMesaOkScreen";
import CookieConsentGlobal from "./components/CookieConsentGlobal";
import Payout from "./pages/PayoutScreen";
import Text from "./pages/TextScreen";
import DataDeletion, { DataDeletionConfirmScreen } from "./pages/DataDeletionScreen";

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Analytics />
        <Routes>
        <Route path="/" element={<Form />} />
        <Route path="/success" element={<SuccessScreen />} />
        {/* IMPORTANTE: Las rutas más específicas deben ir ANTES de las genéricas */}
        <Route path="/:id/success/:idtip" element={<SuccessScreen />} />
        <Route path="/:id/payout/:idtip" element={<Payout />} />
        {/* Landing pages evalúan si hay contenido intermedio, si no, redirigen a FormScreen */}
        <Route path="/event/:id" element={<EventLandingPage />} />
        <Route path="/business/:id" element={<BusinessLandingPage />} />
        {/* Pantalla de la barra: campana de propinas (enlace con token desde la wallet) */}
        <Route path="/campana/:token" element={<CampanaScreen />} />
        {/* Pagar la cuenta de la mesa (QR de mesa con el programa de caja del restaurante) */}
        <Route path="/m/:codigo" element={<CuentaMesaScreen />} />
        <Route path="/m/:codigo/ok/:cobroId" element={<CuentaMesaOkScreen />} />
        {/* Ruta genérica para QR codes: busca eventos, businesses y tipeds */}
        <Route path="/:id" element={<Form />} />
        <Route
          path="/politica-cookies"
          element={<Text id="679c9c22474dd68f9a1080d7" />}
        />
        <Route
          path="/politica-privacidad"
          element={<Text id="679c9bb4474dd68f9a1080c6" showDataDeletionLink />}
        />
        {/* Solicitud pública de eliminación de datos (URL de Google Play) */}
        <Route path="/eliminar-datos" element={<DataDeletion />} />
        <Route path="/delete-data" element={<DataDeletion />} />
        <Route path="/eliminar-datos/confirmar" element={<DataDeletionConfirmScreen />} />
        <Route path="/delete-data/confirm" element={<DataDeletionConfirmScreen />} />
        {/* Ruta catch-all para capturar cualquier ruta no definida y mostrar error en lugar de 404 */}
        <Route path="*" element={
          <div style={{ padding: "20px", textAlign: "center" }}>
            <h2>⚠️ Ruta no encontrada</h2>
            <p>URL: {window.location.href}</p>
            <p>Pathname: {window.location.pathname}</p>
            <p>Search: {window.location.search}</p>
            <p style={{ fontSize: "12px", color: "#666", marginTop: "20px" }}>
              Revisa la consola del navegador para más detalles.
            </p>
          </div>
        } />
        </Routes>
        <CookieConsentGlobal />
      </Router>
    </HelmetProvider>
  );
}

export default App;
